export default "__VITE_ASSET__e0949999__"